export const state = {
  searchData: null,
  summaryStatus: false,
}

export const actions = {
  saveSearchData({ commit }, param) {
    commit('saveSearch', param)
  },
  setSummaryStatus({ commit }, param) {
    commit('saveSummaryStatus', param)
  },
}

export const mutations = {
  saveSearch(state, param){
    state.searchData = param
  },
  saveSummaryStatus(state, param){
    state.summaryStatus = param
  },
}
